<div class="status-banner" [ngClass]="'status-banner--' + variant">
  <i [class]="resolvedIcon + ' status-banner__icon'"></i>
  <div class="status-banner__content">
    <span *ngIf="text">{{ text }}</span>
    <ng-content></ng-content>
  </div>
</div>
